import {h, Fragment} from "preact"
import { useSort } from "@nosto/preact"
import { useEffect, useState, useRef } from "preact/hooks";
import { sortOptions } from "../../config"

export default function SortDropdown() {
    const { activeSort, setSort } = useSort(sortOptions);
    const [ sortOpen, setSortOpen] = useState(false);
    const [hasUserSelected, setHasUserSelected] = useState(false);
    const dropdownRef = useRef(null);
    const toggleRef = useRef(null);

    // keydown 'esc' will close dropdown
    useEffect(() => {
        const handleKeydown = (event) => {
            if(event.key === 'Escape' || event.keyCode === 27) {
                toggleSort();
            }
        }
        if(sortOpen) {
            window.document.addEventListener('keydown', handleKeydown)
            return () => window.document.removeEventListener('keydown', handleKeydown)
        }
    }, [ sortOpen ])

    // click outside will close dropdown
    useEffect(() => {
        const handleClick = (event) => {
            if(
                !dropdownRef.current.contains(event.target) && 
                !toggleRef.current.contains(event.target)
            ) {
                toggleSort();
            };
        };

        if(sortOpen && dropdownRef?.current && toggleRef?.current) {
            window.document.addEventListener('click', handleClick);
            return () => window.document.removeEventListener('click', handleClick);
        };
    }, [sortOpen, dropdownRef, toggleRef]);

    const handleSortChange = (event) => {
        setSort(event.target.value);
        setHasUserSelected(true);
        toggleSort();
    };

    const toggleSort = () => {
        setSortOpen(prevSortOpen => !prevSortOpen);
    };

    // Helper function to get display text
    const getDisplayText = () => {
        if (!hasUserSelected) {
            return "Sort By";
        }
        
        const selectedOption = sortOptions.find(option => option.id === activeSort);
        const optionName = selectedOption ? selectedOption.value.name : "";
        return `Sort By: ${optionName}`;
    };

    return (
        <div class="ns-dropdown-container">
            <div>
                <button
                    className="flex items-center cursor-pointer w-fit ns-sort-btn"
                    type="button"
                    aria-haspopup="true"
                    aria-controls="ns-sort-dropdown"
                    aria-labelledby="sort-label"
                    aria-expanded={sortOpen}
                    tabIndex="0"
                    onClick={toggleSort}
                    ref={toggleRef}
                >
                    <span
                        className="body-2 pr-[5px] pl-[16px] cursor-pointer lg:pl-[30px]"
                        id="sort-label"
                    >
                        {getDisplayText()}
                    </span>
                    <svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M4 9L12 17L20 9" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
                    </svg>
                </button>
            </div>
            <div
                className="absolute bg-white m-w-full z-1"
                id="ns-sort-dropdown"
                aria-hidden={!sortOpen}
                ref={dropdownRef}
                tabIndex="0"
                >
                <ul className="ns-sort-menu bg-background-0 z-30 absolute mt-[20px] w-[200px] h-fit flex flex-col lg:w-[290px] lg:h-auto lg:pr-[0px] lg:right-0 lg:right-auto lg:mt-[2px] lg:top-[30px] lg:pt-[0px]">
                    {sortOptions.map((option) => (
                        <li 
                            key={option.id}
                            class={`ns-sort-option pb-[20px] pl-[20px] pr-[20px] lg:pb-[16px] lg:border-b-0 ${activeSort === option.id ? "selected" : ""}`}
                        >
                            <label
                                className="wrap flex flex-row items-center cursor-pointer"
                            >
                                <input
                                    className="visually-hidden sr-only"
                                    type="radio"
                                    name="ns-sort"
                                    value={option.id} 
                                    checked={(activeSort === option.id)}
                                    onChange={handleSortChange}
                                />
                                <span className={`hover:underline ${activeSort === option.id ? "underline body-2--medium" : ""}`}>
                                    {option.value.name}
                                </span>
                            </label>
                        </li>
                    ))}
                </ul>
            </div>
        </div>
    )
}